import type { StatusTone } from './monitorStatus';

export function quietFor(
  lastFetchIso: string,
  nowMs: number = Date.now()
): { days: number; label: string; tone: StatusTone } {
  const then = new Date(lastFetchIso).getTime();
  if (Number.isNaN(then)) {
    return { days: 0, label: '—', tone: 'neutral' };
  }
  const days = Math.max(0, Math.floor((nowMs - then) / 86_400_000));
  let tone: StatusTone = 'high';
  if (days >= 46) tone = 'low';
  else if (days >= 7) tone = 'medium';
  let label: string;
  if (days === 0) label = 'Today';
  else if (days === 1) label = '1 day';
  else label = `${days} days`;
  return { days, label, tone };
}
